<template>
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
  <router-view />
</template>

<style>
@import 'https://unpkg.com/purecss@2.0.6/build/pure-min.css';

* {
  box-sizing: border-box;
  font-family: 'Karla', 'Lucida Grande', 'Helvetica', 'Arial';
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  padding: 30px;
  color: #2c3e50;
  text-align: center;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
